import { FC } from 'react';
import { ConclusionContainer } from './Conclusion.styles';
import type { ConclusionProps } from './Conclusion.types';
import { EmptyConclusion } from './EmptyConclusion';
import { FactoryGptTextResponse } from '../../../FactoryGptTextResponse';

export const Conclusion: FC<ConclusionProps> = ({ conclusion, isEmpty, labels, name, date }) => {
  return (
    <ConclusionContainer>
      {isEmpty || !conclusion ? (
        <EmptyConclusion labels={labels} name={name} date={date} />
      ) : (
        <FactoryGptTextResponse message={conclusion} />
      )}
    </ConclusionContainer>
  );
};
